<template>
  <div class="EditBomDetailsComponent">
    
    

      {{ lang.label_Name }}:
      <b-form>
        <b-form-input 
          id="inputNameBom"
          class="inputNameBom"
          v-model="form.name"
          :placeholder="lang.placeholder_Name"
          type= "text"
          aria-describedby="input-Name-feedback"
          
        ></b-form-input>
        <b-form-invalid-feedback id="input-Name-feedback" :state="validation_name">
          {{lang.validinfo_name}}
        </b-form-invalid-feedback>
      </b-form>
      
        
        <br>
                
        {{ lang.label_BomNumber }}:
        <b-form-input  
          id="inputNumberBom"
          class="inputNumberBom"
          v-model="form.bomNumber"
          :placeholder="lang.placeholder_BomNumber"
          type= "text"
        ></b-form-input>
        <br>
        
        {{lang.label_Description}}:
        <b-form-textarea
          id="textareaDescriptionBom"
          class="textareaDescriptionBom"
          v-model="form.description"
          :placeholder="lang.textarea_placeholder"
          rows="4"
          max-rows="6"
          ></b-form-textarea>
      

    
  </div>
</template>

<script>


import { mapGetters } from 'vuex'


export default {
  name: "EditBomDetailsComponent",
  components: {



  },
  props:{
    lang: Object,
    data: Object
  },
  data () {
    return {
      name: 'EditBomDetailsComponent',
      form: {
        name: null,
        bomNumber: null,
        description: null
      },
      
      
      
    }
  },
  computed: {
     ...mapGetters({

      //appConf: 'appConf',
    }),
    
    
    validation_name() {
      if (this.form.name.length == 0){
        return false;
      }
      return this.form.name.length > 0;
    },
    
  },
  created() {

       
    this.form.bomId = this.data.bomId;
    this.form.name = this.data.name;
    this.form.bomNumber = this.data.bomNumber;
    this.form.description = this.data.description;

    
  },
  updated(){
    

    this.$store.commit("SETBOMDESCRIPTION", this.form);
    
  },
  methods: {

  }
}
</script>
<style lang="scss">
  .EditBomDetailsComponent{
    
  }



</style>



// WEBPACK FOOTER //
// src/components/shared/EditBomDetailsComponent.vue